import { render, staticRenderFns } from "./AccountSettingsLayout.vue?vue&type=template&id=39ee94ed&scoped=true"
import script from "./AccountSettingsLayout.vue?vue&type=script&lang=js"
export * from "./AccountSettingsLayout.vue?vue&type=script&lang=js"
import style0 from "./AccountSettingsLayout.vue?vue&type=style&index=0&id=39ee94ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ee94ed",
  null
  
)

export default component.exports